// US states with regional cost adjustment factors.
// CA & NY: +40% | TX & FL: base (1.00) | Midwest: -15% | Others: 1.00
const HIGH_COST = new Set(["CA", "NY"]);
const BASE_COST = new Set(["TX", "FL"]);
const MIDWEST = new Set(["IL", "IN", "IA", "KS", "MI", "MN", "MO", "NE", "ND", "OH", "SD", "WI"]);

function toSlug(name) {
  return name.toLowerCase().replace(/\s+/g, "-");
}

const RAW_STATES = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"],
  ["CA", "California"], ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"],
  ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"], ["ID", "Idaho"],
  ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"], ["KS", "Kansas"],
  ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"], ["MD", "Maryland"],
  ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"], ["MS", "Mississippi"],
  ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"],
  ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"], ["NY", "New York"],
  ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"], ["OK", "Oklahoma"],
  ["OR", "Oregon"], ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"],
  ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"],
  ["VT", "Vermont"], ["VA", "Virginia"], ["WA", "Washington"], ["WV", "West Virginia"],
  ["WI", "Wisconsin"], ["WY", "Wyoming"],
];

export const US_STATES = RAW_STATES.map(([code, name]) => ({
  code,
  name,
  slug: toSlug(name),
}));

export function getStateMultiplier(code) {
  if (!code) return 1.0;
  if (HIGH_COST.has(code)) return 1.4;
  if (BASE_COST.has(code)) return 1.0;
  if (MIDWEST.has(code)) return 0.85;
  return 1.0;
}

export function getStateName(code) {
  return US_STATES.find((s) => s.code === code)?.name || "";
}

export function getStateBySlug(slug) {
  return US_STATES.find((s) => s.slug === slug);
}

export function getStateByCode(code) {
  return US_STATES.find((s) => s.code === code);
}

/** Human description of the state's cost adjustment vs. national base. */
export function describeStateAdjustment(code) {
  const m = getStateMultiplier(code);
  if (m > 1.0) return { label: `~${Math.round((m - 1) * 100)}% above national base`, kind: "high" };
  if (m < 1.0) return { label: `~${Math.round((1 - m) * 100)}% below national base`, kind: "low" };
  return { label: "At national base", kind: "base" };
}
